import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=0af735fe&scoped=true&"
import script from "./Tables.vue?vue&type=script&lang=js&"
export * from "./Tables.vue?vue&type=script&lang=js&"
import style0 from "./Tables.vue?vue&type=style&index=0&id=0af735fe&prod&lang=scss&"
import style1 from "./Tables.vue?vue&type=style&index=1&id=0af735fe&prod&lang=scss&"
import style2 from "./Tables.vue?vue&type=style&index=2&id=0af735fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af735fe",
  null
  
)

export default component.exports